import ReportAPI from "../api/report";
import Vue from 'vue'

export const reports = {
    state: {
        hoursByRate: [],
        hoursByRateOptions:{
            selectedYear:0,
            selectedMonth:0,
            selectedStatus:null,
            selectedRate:null,
        },
        hoursByRateLoadStatus: 0,

        dueByRateCategories: [],
        dueByRateCategoriesOptions:{
            selectedYear:0,
            selectedMonth:0,
            selectedRateCategory:null,
        },
        dueByRateCategoriesLoadStatus: 0,
    },

    actions: {
        loadHoursByRate({ state, commit, dispatch }) {
            commit("setHoursByRateLoadStatus", 1);
                ReportAPI.getHoursByRate({
                    selectedYear:state.hoursByRateOptions.selectedYear,
                    selectedMonth:state.hoursByRateOptions.selectedMonth,
                    selectedStatus:state.hoursByRateOptions.selectedStatus,
                    selectedRate:state.hoursByRateOptions.selectedRate
                })
                .then(function(response) {
                    commit("setHoursByRate", response.data);
                    dispatch("applyIndexOnHoursByRate");
                    commit("setHoursByRateLoadStatus", 2);
                })
                .catch(function() {
                    commit("setHoursByRate", []);
                    commit("setHoursByRateLoadStatus", 3);
                });
         
        },

        loadDueByRateCategories({ state, commit, dispatch }) {
            commit("setDueByRateCategoriesLoadStatus", 1);
                ReportAPI.getDueByRateCategories({
                    selectedYear:state.dueByRateCategoriesOptions.selectedYear,
                    selectedMonth:state.dueByRateCategoriesOptions.selectedMonth,
                    selectedRateCategory:state.dueByRateCategoriesOptions.selectedRateCategory
                })
                .then(function(response) {
                    commit("setDueByRateCategories", response.data);
                    dispatch("applyIndexOnDueByRateCategories");
                    commit("setDueByRateCategoriesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setDueByRateCategories", []);
                    commit("setDueByRateCategoriesLoadStatus", 3);
                });
         
        },


        setHoursByRateOptions({ state, commit, dispatch },data){
            commit("setHoursByRateOptions",data.options);
            
            if(data.options.selectedRate)dispatch("loadHoursByRate");
            else commit("setHoursByRate",[]);
        },
     
        applyIndexOnHoursByRate({ commit, state }) {
            let localResults = state.hoursByRate;

            var i = 1;
            localResults.forEach(settlement => {
                settlement.lp = i;
                i++;
            });

            commit("setHoursByRate",localResults);
        },

        setDueByRateCategoriesOptions({ state, commit, dispatch },data){
            commit("setDueByRateCategoriesOptions",data.options);
            dispatch("loadDueByRateCategories");
            //if(data.options.selectedRateCategory)dispatch("loadDueByRateCategories");
            //else commit("setDueByRateCategories",[]);
        },
     
        applyIndexOnDueByRateCategories({ commit, state }) {
            let localResults = state.dueByRateCategories;

            var i = 1;
            localResults.forEach(settlement => {
                settlement.lp = i;
                i++;
            });

            commit("setDueByRateCategories",localResults);
        },
       

    },
    mutations: {
        setHoursByRateOptions(state,options){
            state.hoursByRateOptions = options;
        },
        setHoursByRateLoadStatus(state, status) {
            state.hoursByRateLoadStatus = status;
        },
        setHoursByRate(state, results) {
            state.hoursByRate = results;
        },

        setDueByRateCategoriesOptions(state,options){
            state.dueByRateCategoriesOptions = options;
        },
        setDueByRateCategoriesLoadStatus(state, status) {
            state.dueByRateCategoriesLoadStatus = status;
        },
        setDueByRateCategories(state, results) {
            state.dueByRateCategories = results;
        },
    },

    getters: {
        getHoursByRateOptions(state){
            return state.hoursByRateOptions;
        },
        getHoursByRateLoadStatus(state) {
            return state.hoursByRateLoadStatus;
        },
        getHoursByRate(state) {
            return state.hoursByRate;
        },

        getDueByRateCategoriesOptions(state){
            return state.dueByRateCategoriesOptions;
        },
        getDueByRateCategoriesLoadStatus(state) {
            return state.dueByRateCategoriesLoadStatus;
        },
        getDueByRateCategories(state) {
            return state.dueByRateCategories;
        },
    }
};
